import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';

export class CookiebotConfig extends NgxCookiebotConfig {
  override blockingMode: 'auto' | 'manual' | string = "auto";
  override cbId: string = "12247b9b-e3f4-4f67-8705-a77a376c9aa0";
  override culture?: string;
  override framework?: string;
  override level?: string;
  override type?: string;
}  